import { fetchWithClerkJwt } from "./fetch-with-clerk";

export async function fetchCustomerDeliveryFeeCents(
  getToken: () => Promise<string | null>,
): Promise<number> {
  const res = await fetchWithClerkJwt(getToken, "/api/v1/me/customer-delivery-fee");
  const text = await res.text();
  if (!res.ok) {
    let err = "customer_delivery_fee_unavailable";
    try {
      const j = JSON.parse(text) as { error?: string };
      if (j.error) err = j.error;
    } catch {
      /* ignore */
    }
    throw new Error(err);
  }
  const body = JSON.parse(text) as { customerDeliveryFeeCents?: number };
  return typeof body.customerDeliveryFeeCents === "number" ? body.customerDeliveryFeeCents : 0;
}
